export function removeCookie(cname: string): void {
  const expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC;'
  document.cookie = `${cname}=;${expires};path=/`
}

export function setCookie(cname: string, cvalue: string, hours = 1): void {
  const date = new Date()
  date.setTime(date.getTime() + hours * 60 * 60 * 1000)
  const expires = `expires=${date.toUTCString()}`
  const sameSite = 'SameSite=None;Secure'
  document.cookie = `${cname}=${cvalue};${expires};path=/;${sameSite}`
}

export function getCookie(cname: string): string | null {
  const matches = document.cookie.match(
    new RegExp('(?:^|; )' + cname.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
  )
  return matches ? decodeURIComponent(matches[1]) : null
}
